var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"order-route-list"},[_c('Ellipsis',{attrs:{"text":_vm.route,"length":20}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }